import FieldConfig from "../../../proto/field-config"
import FieldProject_QuickFilterView from "./render/quick-filter-view"
import FieldProject_View from "./render/view"
import FieldProject_ViewSmall from "./render/view-small"
import FieldProject_GlistGroupStandard from "./components/glist-group/standard"
import { FieldProjects_ViewModes } from "../projects/projects"
import FieldProject_FormElement from "./render/form-element"
import FieldProject_FormElementView from "./render/form-element-view"
import FieldPopover from "../../popover/popover"
import mapProject from "../../../import/normalize/map-project"
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldProject_InlineEditable from "./render/inline-editable"
import FieldProject_GlistView from "./render/glist-view"
import {ConstProject} from "../../../../gd/const/project"
import {ColorPalette, ItemColorCoding} from "../../../color-coding/color-coding"
import FieldProject_ViewReference from "./render/view-reference"
import FieldProject_PickerValueEmpty from "./components/picker/value-empty"
import FieldProject_GlistGroupModern from "./components/glist-group/modern"
import FieldProject_ViewProperty from "./render/view-property"
import {FieldFilterType} from "../../../proto/types"
import {EntityType} from "../../../../gd/const/item"
import FieldProject_ConditionForm from "./render/condition"
import {
    FIELD_CONDITIONS_DROPDOWN,
    FieldDropdown_filterFunc,
    FieldDropdown_filterValuesFiller
} from "../../../conditions/dropdown"
import FieldProject_FilterForm from "./render/filter"
import FieldProject_ViewGroup from "./render/group/group"

export default class FieldProject extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 200;

    // parentsFor possible values: "common-use", "event", ConstProject.type.PROJECT ,ConstProject.type.WORKFOLDER,
    // ConstProject.type.BACKLOG, ConstProject.type.SPRINT, ConstProject.type.TAG, "task", "user", "report", 'document'
    public parentsFor           : EntityType | EntityType[]
    public displayWorkspaceRoot : boolean = false
    public canBeNull            : boolean = false

    // viewMode possible values: "all", "projects", "companies"
    public viewMode         : FieldProjects_ViewModes

    public accessLevels     : number[]

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel              = "Parent project"
        this.icon                   = 'ii5-project'
        this.label                  = _.get(config,'label','Project')

        this.placeholder            = _.get(config,'placeholder','Please select');
        this.placeholderIcon        = _.get(config,'placeholderIcon',null)

        this.noValueOption          = _.get(config,'addNoValueOption',true);
        // patch to support noValueOption key
        if (!_.isNil(config.noValueOption)) this.noValueOption = _.get(config,'noValueOption',true);

        this.isFilterAvailable      = true

        this.conditionTypes         = FIELD_CONDITIONS_DROPDOWN

        this.noValueOptionIcon      = _.get(config,'noValueOptionIcon',undefined)
        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','None')

        this.clearButton            = _.get(config,'clearButton',false)

        this.filterType             = FieldFilterType.DROPDOWN_DYNAMIC

        // PARENT (dropdown) specific
        // this.variableName   = '{TASK-PROJECT}'
        this.parentsFor             = _.get(config,'parentsFor', EntityType.PROJECT)
        this.displayWorkspaceRoot   = _.get(config,'displayWorkspaceRoot', false)
        // Enables null selection via the "Projects" root item in the tree (see SelectParentNew canBeNull prop).
        this.canBeNull              = _.get(config,'canBeNull', false)
        this.viewMode               = _.get(config,'viewMode',FieldProjects_ViewModes.ALL)
        this.accessLevels           = _.get(config,'accessLevels',[ConstProject.access.LIMITED, ConstProject.access.STANDARD, ConstProject.access.FULL])

        this.components.glistGroupStandard = FieldProject_GlistGroupStandard
        this.components.glistGroupModern   = FieldProject_GlistGroupModern
        this.components.PickerValueEmpty   = FieldProject_PickerValueEmpty


        this.renderComponents.view              = FieldProject_View
        this.renderComponents.viewSmall         = FieldProject_ViewSmall
        this.renderComponents.inlineEditable    = FieldProject_InlineEditable
        this.renderComponents.formElement       = FieldProject_FormElement
        this.renderComponents.formElementView   = FieldProject_FormElementView
        this.renderComponents.quickFilterView   = FieldProject_QuickFilterView

        this.renderComponents.glistView         = FieldProject_GlistView

        this.renderComponents.viewReference     = FieldProject_ViewReference
        this.renderComponents.viewProperty      = FieldProject_ViewProperty
        this.renderComponents.viewGroup         = FieldProject_ViewGroup

        this.renderComponents.conditionForm     = FieldProject_ConditionForm
        this.renderComponents.filterForm        = FieldProject_FilterForm

        this.filterFunc                         = FieldDropdown_filterFunc
        this.filterValuesFiller                 = FieldDropdown_filterValuesFiller
    }

    // normalize value for group by
    groupValue(value:any) {return value}

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)

        const project = gd.session.projects.get(rawValue)
        return project ? project.name : ''
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return mapProject(gd.companyId, value, module.projectPathSeparator)
    }

    getColorCoding(model: any): ItemColorCoding {
        const value = _.get(model, this.fieldId, null)
        const project = gd.session.projects.get(value)!

        return {
            colorNumber     : project.color,
            corePalette     : ColorPalette.CORE
        }
    }

    groupLabel(value: any): string {
        return gd.session.projects.get(value)?.name || value
    }

    // normalize value for groups sorting
    groupSortValue(value: any):any {
        return this.groupLabel(value)
    }

    /*public getFilterOptions(optionsSet?:Set<any>):Option[] {
        const projectIds : ID[] = [...optionsSet!]

        const result : Option[] = []

        _.map(projectIds, (projectId:ID)=>{
            const project : ProjectSession | null = gd.session.projects.get(projectId)
            if (project) {
                result.push(project.toOption())
            }
        })

        return result
    }*/
}
